import moment from "moment";
import "moment/locale/es";
import { cuentaMask, round2Decimals } from "../Components/Items";
import dayjs from "dayjs";

moment.locale("es");

const to2 = (n) =>
  Number.isFinite(n)
    ? round2Decimals(n)?.toFixed?.(2) ?? (Math.round(n * 100) / 100).toFixed(2)
    : "0.00";

const reporteEntradasSalidasPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;

  // ------------------- Filtros (incluye periodo) -------------------
  const filtrados = [];

  const start = values?.rango?.startDate
    ? moment(values.rango.startDate).format("LL")
    : moment(values.periodo?.[0]).format("LL");
  const end = values?.rango?.endDate
    ? moment(values.rango.endDate).format("LL")
    : moment(values.periodo?.[1]).format("LL");

  filtrados.push([
    { text: "Periodo:", style: "subheader" },
    { text: `Del ${start} al ${end}`, style: "textoChico" },
  ]);

  if (values.filtrarProyecto === 1 && Array.isArray(values.proyectos)) {
    let textoFiltrado = "";
    values.proyectos.forEach((p) => (textoFiltrado += `${p.nombre}\n`));
    filtrados.push([
      { text: "Proyectos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }

  if (values.filtrarProyecto === 2 && values.unidadDeNegocio) {
    filtrados.push([
      { text: "Unidad de Negocio:", style: "subheader" },
      {
        text:
          cuentaMask(
            values.unidadDeNegocio.nivel1 +
              values.unidadDeNegocio.nivel2 +
              values.unidadDeNegocio.nivel3 +
              values.unidadDeNegocio.nivel4 +
              values.unidadDeNegocio.nivel5
          ) +
          " - " +
          values.unidadDeNegocio.nombre,
        style: "textoChico",
      },
    ]);
  }

  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  // ------------------- Encabezados de tabla -------------------
  const headerRow1 = [
    { text: "Fecha",        style: "tituloTabla", alignment: "center" },
    { text: "E/S",        style: "tituloTabla", alignment: "center" },
    { text: "Clave",  style: "tituloTabla", alignment: "center" },
    { text: "Descripción",  style: "tituloTabla", alignment: "center" },
    { text: "Familia",      style: "tituloTabla", alignment: "center" },
    { text: "Marca",       style: "tituloTabla", alignment: "center" },
    { text: "Unidad",     style: "tituloTabla", alignment: "center" },
    { text: "Cantidad",     style: "tituloTabla", alignment: "center" },
    { text: "Costo U.",     style: "tituloTabla", alignment: "center" },
    { text: "Proveedor",    style: "tituloTabla", alignment: "center" },
    { text: "Documento",    style: "tituloTabla", alignment: "center" },
    { text: "Concepto",     style: "tituloTabla", alignment: "center" },
  ];

  const movimientosRows = (values.movimientos || []).map((it) => [
    { text: dayjs(it.createdAt).format("DD/MM/YYYY"),           style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.salida ? "Salida" : "Entrada",     style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.claveInsumo,         style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.descripcionInsumo,   style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.nombreFamilia,      style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.nombreMarca,       style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.nombreUnidad,     style: "textoTabla", alignment: "left",  noWrap: false },
    { text: to2(it.cantidad),     style: "textoTabla", alignment: "right", noWrap: false },
    // Solo las recepciones de compra traen costo, proveedor y documento; en un
    // ajuste manual o un traspaso las tres celdas quedan vacias.
    { text: it.costo ? to2(it.costo) : "",     style: "textoTabla", alignment: "right", noWrap: false },
    { text: it.proveedorNombre || "",     style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.documentoCompra || "",     style: "textoTabla", alignment: "left",  noWrap: false },
    { text: it.concepto,     style: "textoTabla", alignment: "left",  noWrap: false },
  ]);

  const dd = {
    footer: { image: "logoBiwo", alignment: "center", width: 80 },

    content: [
      // === INFO (misma primera hoja) ===
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: { defaultBorder: false },
          body: [[
            { border: [false, false, false, false], image: "logo", fit: [80, 80] },
            {
              border: [false, false, false, false],
              table: {
                headerRows: 1,
                widths: ["100%"],
                body: [
                  [{ text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : `${empresa.nombre} ${empresa.apellidoPaterno} ${empresa.apellidoMaterno}`), style: "tableHeader" }],
                  [{ text: "R.F.C: " + (empresa.rfc || ""), style: "textoChico", alignment: "center" }],
                  [{ text: `${empresa.calle || ""} ${empresa.numeroCalle || ""} ${empresa.numeroInterior || ""}`, style: "textoChico", alignment: "center" }],
                  [{ text: `${empresa.colonia?.tipoAsentamiento || ""} ${empresa.colonia?.nombre || ""} C.P. ${empresa.colonia?.cp || ""} ${empresa.municipio?.nombre || ""} ${empresa.estado?.abreviatura || ""} ${empresa.pais?.abreviatura || ""}`, style: "textoChico", alignment: "center" }],
                  [{ text: "REPORTE DE ENTRADAS Y SALIDAS DE INVENTARIO", style: "tableHeader" }],
                ],
              },
              layout: "noBorders",
            },
            {
              border: [false, false, false, false],
              table: {
                headerRows: 1,
                widths: ["100%"],
                body: [
                  [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
                  [{ text: moment().locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                ],
              },
              layout: "noBorders",
            },
          ]],
        },
      },

      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "80%"],
          layout: { defaultBorder: false },
          body: filtrados,
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
          hLineStyle: (i, node) => (i === 0 || i === node.table.body.length ? null : { dash: { length: 2, space: 1 } }),
          vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } }),
        },
      },

      // === TABLA (arranca en la misma hoja) ===
      {
        style: "tableExample",
        table: {
          // LETTER landscape (~792pt) con márgenes 20 => ancho útil ~752pt.
          // Con Costo U. / Proveedor / Documento son 12 columnas: se recortó
          // Descripción y Concepto para hacerles lugar. La suma tiene que dar
          // 100% y haber exactamente un ancho por celda de la fila, o pdfmake
          // se sale de la hoja.
          widths: ["7%", "5%", "8%", "16%", "8%", "7%", "5%", "6%", "7%", "13%", "8%", "10%"],
          headerRows: 2,
          // permite que el contenido siga en páginas siguientes y repita headers
          body: [
            headerRow1,
            ...movimientosRows,
          ],
        },
        layout: {
          // Reducimos padding para ganar espacio horizontal
          paddingLeft:   () => 2,
          paddingRight:  () => 2,
          paddingTop:    () => 2,
          paddingBottom: () => 2,
          fillColor: (rowIndex) => (rowIndex < 2 ? null : rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
          hLineStyle: (i, node) => (i === 0 || i === node.table.body.length ? null : { dash: { length: 2, space: 1 } }),
          vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } }),
        },
      },
    ],

    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },

    styles: {
      header:       { fontSize: 9, bold: true },
      subheader:    { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeader:  { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico:   { fontSize: 8 },
      tituloTabla:  { fontSize: 8, bold: true, fillColor: "#cccccc", alignment: "center", border: true },
      textoTabla:   { fontSize: 8, italics: false },
    },

    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [20, 20, 20, 60],
  };

  return dd;
};

export default reporteEntradasSalidasPdf;
